function replayTimelineTickRatio(tick, durationTicks) {
  if (durationTicks <= 0) return 0
  return Math.max(0, Math.min(1, tick / durationTicks))
}

export function replayTimelineRatioToTick(ratio, durationTicks) {
  const r = Math.max(0, Math.min(1, ratio))
  const t = Math.round(r * durationTicks)
  return Math.min(durationTicks, Math.max(0, t))
}

export function createReplayTimelineUiUpdater(o) {
  return function updateReplayTimelineUi() {
    const pos = o.getAppliedSteps()
    const r = replayTimelineTickRatio(pos, o.durationTicks)
    o.trackFill.style.width = `${r * 100}%`
    o.playhead.style.left = `${r * 100}%`
    o.tickCur.textContent = String(pos)
    o.tickMax.textContent = String(o.durationTicks)
  }
}

function rosterDisplayName(players, id) {
  if (id == null || id === '') return ''
  const p = (players ?? []).find(x => String(x.id) === String(id))
  return p?.name ? String(p.name) : String(id)
}

function replayRipMarkerText(d, gameMode, players) {
  const victim = d.name || rosterDisplayName(players, d.playerId) || 'Ship'
  const feedMode = gameMode === 'deathmatch' || gameMode === 'ctf'
  if (feedMode && d.hitBy) {
    return `${rosterDisplayName(players, d.hitBy)} → ${victim}`
  }
  return `${victim} died`
}

export function mountReplayTimelineRipMarkers(container, deaths, durationTicks, gameMode, players) {
  container.innerHTML = ''
  for (const d of deaths) {
    const tick = d.tick ?? 0
    const mark = document.createElement('span')
    mark.className = 'replay-rip-marker'
    mark.style.left = `${replayTimelineTickRatio(tick, durationTicks) * 100}%`
    const label = document.createElement('span')
    label.className = 'replay-floating-label'
    const text = replayRipMarkerText(d, gameMode, players)
    label.textContent = text
    mark.appendChild(label)
    container.appendChild(mark)
  }
}

export function bindTimelineTrackScrub(o) {
  let scrubWasPlaying = false
  let dragScrub = false

  const onPointerScrubEnd = () => {
    const resume = scrubWasPlaying
    scrubWasPlaying = false
    dragScrub = false
    o.trackHit.removeAttribute('data-scrubbing')
    o.restoreMuteAfterScrub?.()
    if (resume) o.resumePlaybackAfterScrub()
  }

  const onPointerDown = e => {
    if (e.pointerType === 'mouse' && e.button !== 0) return
    scrubWasPlaying = o.getPlaying()
    dragScrub = true
    o.pausePlayback()
    o.trackHit.setAttribute('data-scrubbing', '')
    o.muteForScrub?.()
    o.trackHit.setPointerCapture(e.pointerId)
    o.onTrackPointer(e.clientX)
    e.preventDefault()
  }

  const onPointerMove = e => {
    if (!dragScrub) return
    o.onTrackPointer(e.clientX)
  }

  const subs = [
    ['pointerdown', onPointerDown],
    ['pointermove', onPointerMove],
    ['pointerup', onPointerScrubEnd],
    ['pointercancel', onPointerScrubEnd],
    ['lostpointercapture', onPointerScrubEnd]
  ]
  for (const [type, fn] of subs) o.trackHit.addEventListener(type, fn)

  return function disposeTimelineTrackScrub() {
    o.restoreMuteAfterScrub?.()
    for (const [type, fn] of subs) o.trackHit.removeEventListener(type, fn)
  }
}
